module.exports = __webpack_public_path__ + "static/particulas-cd3026bd9dbbfdeafee8bb398ad97fb2.webp";